'use strict';

/** Import LocationHandler class */
import LocationHandler from '../location_handler/location_handler';

/** @const BACK_OFFICE_ERROR_TEMPLATE */
const BACK_OFFICE_ERROR_TEMPLATE = 'backoffice';

/** @const FRONT_END_ERROR_TEMPLATE */
const FRONT_END_ERROR_TEMPLATE = 'frontoffice';

/**
 * @class ErrorHandler
 */
class ErrorHandler
{
    /**
     * @param status
     * @param message
     */
    handleError (status, message)
    {
        this.constructor._storeErrorObject('The server returned a ' + status + ' ' + message);
        LocationHandler.redirect('utility/error/' + this.constructor._getErrorTemplate());
    }

    /**
     * @returns {*}
     */
    retrieveError ()
    {
        return this.constructor._getErrorObject();
    }

    /**
     * Clear error
     */
    clearError ()
    {
        this.constructor._clearErrorObject();
    }

    /**
     * @param error
     * @private
     */
    static _storeErrorObject (error)
    {
        localStorage.setItem('responseError', error);
    };

    /**
     * @returns {string | null}
     * @private
     */
    static _getErrorObject ()
    {
        return localStorage.getItem('responseError');
    }

    /**
     * @private
     */
    static _clearErrorObject ()
    {
        localStorage.removeItem('responseError');
    }

    /**
     * @returns {string}
     * @private
     */
    static _getErrorTemplate ()
    {
        let currentLocation = LocationHandler.getCurrentLocation();
        return (currentLocation.indexOf('/backoffice') > 0) ? BACK_OFFICE_ERROR_TEMPLATE : FRONT_END_ERROR_TEMPLATE;
    }
}

/** @export ErrorHandler */
export default new ErrorHandler();


// WEBPACK FOOTER //
// ./assets/js/shared/utility/error_handler/error_handler.js